import { Component, OnInit } from '@angular/core';
import { PoPageDefault, PoBreadcrumb, PoBreadcrumbItem, PoDialogService, PoNotificationService, PoSelectOption, PoTableColumn } from '@po-ui/ng-components';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Location } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { FsbcamposService } from 'src/app/services/campos/fsbcampos.service';
import { DicionarioService } from 'src/app/services/dicionario/dicionario.service';
import { UtilService } from 'src/app/services/util-service/util.service';
import { GetDadosService } from 'src/app/services/get-dados/get-dados.service';
import { SessionService } from 'src/app/services/session/session.service';
import { CotacaoService } from 'src/app/services/cotacao/cotacao.service';

@Component({
  selector: 'app-cotacao-aberto-edit',
  templateUrl: './cotacao-aberto-edit.component.html',
  styleUrls: ['./cotacao-aberto-edit.component.css']
})
export class CotacaoAbertoEditComponent implements OnInit {

  public page: PoPageDefault = {
    title: '',
    breadcrumb: <PoBreadcrumb>{
      items: <PoBreadcrumbItem[]>[]
    },
    actions: []
  }
  public dados: Object = {};
  private idCotacao: string = '';
  public arrHeaders: Array<Object> = [];
  public arrFields: Array<Object> = [];
  public tipoTela: string = '';
  public loading: boolean = true;
  public disabledField: boolean = false;
  public disabledFieldEdit: boolean = false;
  public informacoesFornecedor: string = '';

  public table = {
    columns: <any[]>[],
  }

  tableItens = []

  public selects = {
    condicaoPagamento: {}
  }

  constructor(
    private router: Router,
    private actRoute: ActivatedRoute,
    private poDialog: PoDialogService,
    private location: Location,
    private notificationService: PoNotificationService,
    private fsbCampos: FsbcamposService,
    private dicionarioService: DicionarioService,
    private utilService: UtilService,
    private getDadosService: GetDadosService,
    private sessionService: SessionService,
    private cotacaoService: CotacaoService
  ) { }

  ngOnInit(): void {

    this.sessionService.info$
      .subscribe((data) => {
        this.informacoesFornecedor = ` Informações do Cabeçalho  CNPJ: ${data['FORNECEDOR'][0]['A2_CGC']} - NOME: ${data['FORNECEDOR'][0]['A2_NOME']}`;
        this.dados['A2_CGC'] = data['FORNECEDOR'][0]['A2_CGC'];
        this.dados['A2_NOME'] = data['FORNECEDOR'][0]['A2_NOME'];
      });

    if (this.router.url.indexOf('edit') != -1) {
      this.tipoTela = 'edit';
      this.page.title = 'Alterar Cotação';
      this.page.actions = [
        { label: 'Ok', action: () => { this.alterarCotacao() } },
        { label: 'Cancelar', action: () => this.cancelarFn() },
      ];
      this.page.breadcrumb.items = [
        { label: 'Home' },
        { label: 'Cotação' },
        { label: 'Alterar Cotação' },
      ];
      this.actRoute.paramMap.subscribe((paramMap: ParamMap) => {
        this.idCotacao = paramMap.get('idCotacao');
      });
      this.getDicionario();
      this.disabledFieldEdit = false;
      this.disabledField = true;
    } else {
      this.tipoTela = 'view';
      this.page.title = 'Visualizar Cotação';
      this.page.actions = [
        { label: 'Ok', disabled: true },
        { label: 'Cancelar', action: () => this.cancelarFn() },
      ];
      this.page.breadcrumb.items = [
        { label: 'Home' },
        { label: 'Cotação' },
        { label: 'Visualização Cotação' },
      ];
      this.actRoute.paramMap.subscribe((paramMap: ParamMap) => {
        this.idCotacao = paramMap.get('idCotacao');
      });
      this.getDicionario();
      this.disabledField = true;
      this.disabledFieldEdit = true;
    }
  }

  calculaPrecoAplicado(item) {
    let precoAplicado = item['C8_QUANT'] * item['C8_PRECO'];
    item['C8_TOTAL'] = precoAplicado.toFixed(2)
  }

  teste

  private getDicionario(tabela?: string) {
    this.loading = true;
    let obj = {
      tabela: 'SC8'
    }
    this.dicionarioService
      .fsbDicionario(this.utilService.getParameters(obj))
      .subscribe((data: any) => {

        let auxiliarColumns: Array<any> = data['dados'][0]['dynamicView'][0]['fields'];

        auxiliarColumns = auxiliarColumns.filter(item => item['used'] == true);

        this.fsbCampos.getCampos('cota')
          .subscribe((data) => {
            this.teste = data['fields']

            this.arrHeaders = [];

            /* Inicio da lógica dos headers*/

            var header = [];

            auxiliarColumns.filter(function (element, index, array) {
              if (data['header'].indexOf(element['property']) == -1)
                return element
              return header.push(element);
            })

            console.log(header);


            header.sort((a, b) => {
              if (a['sequence'] < b['sequence']) {
                return -1;
              } else if (a['sequence'] > b['sequence']) {
                return 1;
              } else {
                return 0;
              }
            });


            header.map((item) => {
              let select: boolean = false;
              let options: Array<PoSelectOption> = [];
              if (item['option'].length > 0) {
                select = true;
                let arr: Array<string> = item['option'].split(';');
                options = arr.map((item) => {
                  let d = item.split('=');
                  return <PoSelectOption>{ value: d[0], label: d[1] }
                });
              }

              this.arrHeaders.push({ property: item['property'], label: item['label'], type: item['TIPO'], f3: item['F3'].length > 0 ? true : false, readonly: item['readonly'], options: options, select: select, tabela: item['F3'], tamanho: item['width'] });
            })
            /* Fim da lógica dos headers*/

            /* Inicio da lógica dos fields*/


            var fields = [];

            this.arrFields = auxiliarColumns.filter(function (element, index, array) {

              if (data['fields'].indexOf(element['property']) == -1)
                return element
              return fields.push(element);
            })

            console.log(fields);


            fields.sort((a, b) => {
              if (a['sequence'] < b['sequence']) {
                return -1;
              } else if (a['sequence'] > b['sequence']) {
                return 1;
              } else {
                return 0;
              }
            });

            fields.map((item) => {
              let select: boolean = false;
              let options: Array<PoSelectOption> = [];
              if (item['option'].length > 0) {
                select = true;
                let arr: Array<string> = item['option'].split(';');
                options = arr.map((item) => {
                  let d = item.split('=');
                  return <PoSelectOption>{ value: d[0], label: d[1] }
                });
              }

              this.arrFields.push({ property: item['property'], label: item['label'], type: item['TIPO'], f3: item['F3'].length > 0 ? true : false, readonly: item['readonly'], options: options, select: select, tabela: item['F3'] });

              let pixels: number = parseInt(item['width'], 10) * 25;
              if (pixels <= 125) {
                pixels = 125;
              } else if (pixels > 200) {
                pixels = 200;
              } else {
                pixels = parseInt(item['width'], 10) * 25;
              }

              let obj: PoTableColumn = {}

              let typeTable = ''
              let formatTable = ''

              if (item['TIPO'] === "D") {
                typeTable = 'date';
                formatTable = 'dd/MM/yyyy'
              } else if (item['TIPO'] == 'N') {
                obj.type = 'number';
              }

              obj = { label: item['label'], property: item['property'], width: `${pixels}px`, type: `${typeTable}`, format: `${formatTable}` };

              this.table.columns.push(obj);
            })


            /* Fim da lógica dos fields*/

          })

        // /* Select de Especie do Documento */

        let condicaoPagamento = this.actRoute.snapshot.data.condicaoPagamento['dados'];
        let arrCondicaoPagamento = condicaoPagamento.map((item) => {
          return <PoSelectOption>{ label: item['CONCATENADO_SE4'], value: item['E4_CODIGO'] };
        })
        this.selects.condicaoPagamento = arrCondicaoPagamento;

        let dadosHeader = {
          registro: this.idCotacao,
          tabela: 'SC8'
        }

        this.getDetailHeader(this.utilService.getParameters(dadosHeader));

        // let dadosFields = {
        //   registro: this.idCotacao,
        //   tabela: 'SC8'
        // }

        // this.getDetailFields(this.utilService.getParameters(dadosFields));
        this.loading = false;
      },
        (error: HttpErrorResponse) => {
          this.notificationService.error('Error ao carregar os dados!');
          console.log(error.error);
        })
  }

  private getDetailHeader(parameters: any) {
    this.loading = true;
    this.getDadosService
      .getBrowserDetail(parameters)
      .subscribe((data) => {
        this.dados = Object.assign(this.dados, data['dados'][0]);
        this.tableItens = data['dados'];
        // this.loading = false;
      },
        (error: HttpErrorResponse) => {
          console.log('Error ao obter detalhes da Pré Nota', error.error);
          this.loading = false;
        })
  }

  private cancelarFn() {
    this.poDialog.confirm({
      title: `Deseja Cancelar a ${this.tipoTela == 'add' ? 'Inserção' : this.tipoTela == 'edit' ? 'Edição' : this.tipoTela == 'view' ? 'Visualização' : 'Exclusão'}?`,
      message: `${this.tipoTela == 'view' || this.tipoTela == 'delete' ? '' : 'Você irá perder todos os dados digitados.'}`,
      confirm: () => this.location.back(),
      literals: { confirm: 'Sim', cancel: 'Não' }
    })
  }


  private alterarCotacao() {
    this.loading = true;

    // console.log(this.dados);

    // let x = [this.dados]

    // var envio = [];

    // this.arrFields = x.filter(function (element, index, array) {

    //   if (this.teste.indexOf(element['property']) == -1)
    //     return element
    //   return envio.push(element);
    // })

    // console.log(envio);

    let envio = {
      "C8_NUM": this.dados['C8_NUM'],
      "C8_COND": this.dados['C8_COND'],
      "C8_DESPESA": this.dados['C8_DESPESA'],
      "C8_SEGURO": this.dados['C8_SEGURO'],
      "C8_TOTFRE": this.dados['C8_TOTFRE'],
      "A2_CGC": this.dados['A2_CGC'],
      "A2_NOME": this.dados['A2_NOME'],
      "empresa": 'empresa',
      "filial": 'filial'
    }
    console.log(envio);



    let obj = this.tableItens

    let final: any = []

    let itens: any

    obj.map((item) => {

      itens = {
        "C8_NUMPRO": item['C8_NUMPRO'],
        "C8_PRODUTO": item['C8_PRODUTO'],
        "C8_ITEM": item['C8_ITEM'],
        "C8_UM": item['C8_UM'],
        "C8_QUANT": item['C8_QUANT'],
        "C8_PRECO": item['C8_PRECO'],
        "C8_TOTAL": item['C8_TOTAL']
      }

      final.push(itens)
    })

    let opcao = 3

    let postJson = { "OPCAO": opcao, "CABEC": envio, "ITEM": final };
    console.log(postJson);

    // var obj = { name: "John", age: 30, city: "New York" };
    var myJSON = JSON.stringify(postJson);
    console.log(myJSON);
    

    this.cotacaoService.salvarCotacao(postJson)
      .subscribe((data) => {
        if (data['gravado'] == false) {
          this.poDialog.alert({
            title: `Erro ao Editar Cotação`,
            message: data['mensagem'],
            ok: () => ('')
          })
          this.loading = false;
        } else {
          this.notificationService.success(data['mensagem'])
          this.loading = false;
          this.router.navigate(['/cotacao/em-aberto'])
        }
      },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.poDialog.alert({
            title: `Erro ao Editar Cotação`,
            message: error['message'],
            ok: () => ('')
          });
          this.loading = false;
        })
  }

}
